
import t from "../../../../service/translate.service";
import { Modal } from "antd";

const SlotInProgressModal = (props) => {

  return (
    <Modal
      open={true}
      onCancel={() => props.setShowSlotInProgressModal(false)}
      footer={[
        <button
          className="button primary small"
          key="ok"
          onClick={() => props.setShowSlotInProgressModal(false)}
          aria-label={t.CLOSE_SLOT}
        >
          {t.CONSULTATIONS_OK}
        </button>
      ]}
      aria-labelledby="slotInProgressModalTitle"
      role="dialog"
      aria-live="assertive"
    >
      <div className="modal-body-wrapper">
        <p className="modal-p" id="slotInProgressModalTitle" aria-live="assertive" role='alert'>
          {t.CONSULTATIONS_IN_PROGRESS_BOOKED_DATE}
        </p>
      </div>
    </Modal>
  );
};

export default SlotInProgressModal;
